import { api } from "./api";


export const usersListApi = (params) => {
    return api.get(`/hub/user/list`, { params: params });
};

export const userInviteApi = (params) => {
    return api.post(`/hub/user/invite`, JSON.stringify(params));
};

export const portalDropDownApi = (params) => {
    return api.get(`/hub/user/portal-list`, { params: params });
};

export const userViewApi = (params) => {
    return api.get(`/hub/user/view`, { params: params });
};

export const userEditApi = (params) => {
    return api.post(`/hub/user/edit`, JSON.stringify(params));
};

export const userDeleteApi = (params) => {
    return api.post(`/hub/user/delete`, JSON.stringify(params));
};

export const getLoginReportApi = (params) => {
    return api.get(`/hub/user/get-login-report`, { params: params });
};

export const removePortalApi = (params) => {
    return api.post(`/hub/user/remove-portal`, JSON.stringify(params));
};